import { useMutation } from "react-query";
import { createCaregiverInvolvement, updateCaregiverInvolvement } from "api/clinicalManagement";
import { useGlobalToast } from "components/GlobalToastProvider";

const useSaveCaregiverInvolvement = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({
      clientId,
      recordId,
      payload,
    }: {
      clientId: number;
      recordId?: number;
      payload: Record<string, any>;
    }) =>
      recordId
        ? updateCaregiverInvolvement(recordId, payload)
        : createCaregiverInvolvement(clientId, payload),
    {
      onError: (error, variables, context) => {
        showToast({
          message: "Whoops! Something went wrong while saving caregiver involvement.",
          errorState: true,
        });
        onError(error, variables, context);
      },
      ...otherOptions,
    }
  );

  return {
    saveCaregiverInvolvementMutation: mutate,
    isSaveCaregiverInvolvementLoading: isLoading,
    ...rest,
  };
};

export default useSaveCaregiverInvolvement;
